<div class="shell" [class.shell--impersonating]="actingOrgSlug() !== null">
  <div class="shell__body">
    <aside class="rail" [class.rail--collapsed]="collapsed()">
      <button
        type="button"
        class="rail__tenant"
        [title]="branding().displayName"
        (click)="openSwitcher()"
        [disabled]="!isDavacoAdmin()"
      >
        <span class="rail__tile">
          <app-brand-logo class="rail__logo" [src]="branding().logoUrl" [name]="branding().displayName" />
        </span>
        @if (!collapsed()) {
          <span class="rail__names">
            <span class="rail__name">{{ branding().displayName }}</span>
            <span class="rail__role">
              {{ actingOrgSlug() !== null ? 'Admin preview' : 'Customer Portal' }}
            </span>
          </span>
          @if (isDavacoAdmin()) {
            <app-nav-icon class="rail__switch" name="chevron" [size]="14" />
          }
        }
      </button>

      <nav class="rail__nav">
        @for (section of nav(); track section.label) {
          <div class="rail__section">
            @if (!collapsed()) {
              {{ section.label }}
            }
          </div>
          @for (item of section.items; track item.route) {
            <a
              class="rail__item"
              [routerLink]="item.route"
              routerLinkActive="rail__item--active"
              [title]="item.label"
            >
              <app-nav-icon [name]="item.icon" />
              @if (!collapsed()) {
                <span class="rail__label">{{ item.label }}</span>
              }
            </a>
          }
        }
      </nav>

      <div class="rail__spacer"></div>

      <button type="button" class="rail__collapse" (click)="toggleCollapsed()">
        <app-nav-icon name="panel" />
        @if (!collapsed()) {
          <span>Collapse</span>
        }
      </button>

      <div class="rail__poweredby">
        <span class="rail__davaco">
          <img src="/assets/brand/davaco.svg" alt="" aria-hidden="true" />
        </span>
        @if (!collapsed()) {
          <span>Powered by Davaco</span>
        }
      </div>
    </aside>

    <div class="shell__main">
      @if (actingOrgSlug() !== null) {
        <div class="impersonation" role="status">
          <span class="impersonation__badge">
            <app-nav-icon name="eye" [size]="14" />
            Viewing as
          </span>
          <span>{{ user()?.email }} · {{ branding().displayName }}</span>
          <span class="impersonation__sep">·</span>
          <span class="impersonation__note">Read-only · actions are logged</span>
          <span class="impersonation__spacer"></span>
          <button type="button" class="impersonation__exit" (click)="returnToDavacoView()">
            Exit
          </button>
        </div>
      }

      <header class="header">
        <div class="header__titles">
          <div class="header__title">{{ pageTitle() }}</div>
          @if (pageSubtitle(); as subtitle) {
            <div class="header__subtitle">{{ subtitle }}</div>
          }
        </div>

        @if (isDavacoAdmin()) {
          <button type="button" class="header__search" (click)="openSwitcher()">
            <app-nav-icon name="search" [size]="14" />
            <span class="header__searchtext">Switch organization</span>
            <kbd class="header__kbd">⌘K</kbd>
          </button>
        }

        <button type="button" class="header__icon" aria-label="Notifications">
          <app-nav-icon name="bell" />
          <span class="header__dot" aria-hidden="true"></span>
        </button>

        <button
          type="button"
          class="header__user"
          [class.header__user--impersonating]="actingOrgSlug() !== null"
          (click)="signOut()"
        >
          <span class="header__avatar">{{ initials() }}</span>
          <span class="header__username">{{ user()?.name }}</span>
          <app-nav-icon name="chevron" [size]="12" />
        </button>
      </header>

      <router-outlet />
    </div>
  </div>

  @if (isDavacoAdmin()) {
    <app-org-switcher />
  }
</div>
